export default defineNuxtPlugin(async () => {
  const { t } = await useI18n()
  return {
    provide: {
      t: (key: string, data?: any) => {
        return t(key, data)
      }
    }
  }
})
